var CreateGpuProcessor = require('../../utils/gpu-processor/gpu-processor')

var DuplicateBufferGeometry = require('../../utils/duplicate-buffer-geometry')
var CopyTexture = require('../../utils/gpu-processor/copy-texture')

const PASS_THROUGH_VERT = "void main() { gl_Position = vec4( position, 1.0 ); }"

function _generatePositionFn( config ) {
	
	return function generatePosition( data, i ) {
		
		var r     = Math.random() * 2
		let theta = Math.random() * Math.PI * 2
		let phi   = Math.random() * Math.PI * 2

		data[i+0] = r * Math.sin( theta ) * Math.cos( phi )
		data[i+1] = r * Math.sin( theta ) * Math.sin( phi )
		data[i+2] = r * Math.cos( theta )
		
		if( Math.random() < 1/3 ) {
			data[i+0] += 2
			data[i+1] += -1
			data[i+2] += 1
		} else if( Math.random() > 0.5 ) {
			data[i+0] += -2
			data[i+1] += -1
			data[i+2] += 0
		} else {
			data[i+1] += 1
			data[i+2] += -1
		}
		
		data[i+0] *= 1
		data[i+1] *= 0.5
		data[i+2] *= 1
	}
}

function _initPositioningPass( poem, gpuProcessor, stats, config ) {
	
	var prevPositionTexture // created at the end
	
	var shaderMaterial = new THREE.ShaderMaterial({
		
		vertexShader : PASS_THROUGH_VERT,
		fragmentShader : "#define GLSLIFY 1\n\nuniform float textureSideLength;\nuniform float elapsed;\n\nuniform sampler2D textureCurrPosition;\nuniform sampler2D texturePrevPosition;\n\nuniform float velocity;\nuniform float cohesionDistance;\nuniform float cohesionWeight;\nuniform float repulsionDistance;\nuniform float repulsionWeight;\nuniform float alignmentDistance;\nuniform float alignmentWeight;\nuniform float mouseDistance;\nuniform float mouseWeight;\n\nuniform vec3 mouseOrigin;\nuniform vec3 mouseDirection;\n\n\nstruct boidsState {\n\tvec3 cohesion;\n\tvec3 repulsion;\n\tvec3 alignment;\n\tvec3 mouse;\n};\n\nvec4 _positionFromIndex( in sampler2D texturePositions, in int index ) {\n\t\n\tvec2 uv = vec2(\n\t\tmod(float(index), textureSideLength),\n\t\tfloor( float(index) / textureSideLength )\n\t);\n\t\n\treturn texture2D( texturePositions, uv / textureSideLength );\n}\n\nvoid _boidsCalculations( in vec3 positionA, in vec3 positionB, in vec3 prevPositionB, inout boidsState current) {\n\t\n\tvec3 diff = positionB - positionA;\n\tvec3 orientationB = normalize(positionB - prevPositionB);\n\tfloat diffLength = length( diff );\n\t\n\tfloat cohesionWeight  = max(0.0, 1.0 - diffLength / cohesionDistance);\n\tfloat repulsionWeight = max(0.0, 1.0 - diffLength / repulsionDistance);\n\tfloat alignmentWeight = max(0.0, 1.0 - diffLength / alignmentDistance);\n\t\n\tcurrent.cohesion  += diff * cohesionWeight;\n\tcurrent.repulsion += -diff * repulsionWeight;\n\tcurrent.alignment += orientationB * alignmentWeight;\n}\n\nfloat _fleeMouse( in vec3 position ) {\n\t/*\n\t\n\tfloat directionDistance = dot( (position - mouseOrigin), mouseDirection );\n\t\n\t// point behind the ray\n\t// if ( directionDistance < 0 ) {\n\t//\n\t// \treturn this.origin.distanceToSquared( point );\n\t//\n\t// }\n\t\n\tvec3 projectedPoint = (mouseDirection * directionDistance) + mouseOrigin;\n\tfloat distanceToMouse = length( projectedPoint - position );\n\t\n\treturn max(1.0, mouseDistance - distanceToMouse);\n\t*/\n\t\n\tfloat distanceToMouse = length( cross( mouseDirection, position - mouseOrigin ) );\n\treturn max(1.0, mouseDistance - distanceToMouse);\n\t\n}\n\nvoid main() {\n\t\n\tvec2 uv = gl_FragCoord.xy / textureSideLength;\n\tvec3 currPositionA = texture2D( textureCurrPosition, uv ).xyz;\n\tvec3 prevPositionA = texture2D( texturePrevPosition, uv ).xyz;\n\tvec3 velocityA = currPositionA - prevPositionA;\n\tvec3 orientationA = normalize( velocityA );\n\tfloat currentIndex = textureSideLength * uv.y + uv.x;\n\t\n\tboidsState boids = boidsState( vec3(0.0), vec3(0.0), vec3(0.0), vec3(0.0) );\n\t\n\tfor(int i = 0; i < TOTALCOUNT; i++) {\n\t\t\n\t\tvec3 currPositionB = _positionFromIndex( textureCurrPosition, i ).xyz;\n\t\tvec3 prevPositionB = _positionFromIndex( textureCurrPosition, i ).xyz;\n\t\t\n\t\t_boidsCalculations( currPositionA, currPositionB, prevPositionB, boids );\n\t}\n\t\n\t// float mouseFleeAmount = _fleeMouse( currPositionA );\n\t\n\tvec3 target = vec3(\n\t\tcos(elapsed * -0.1) * 1.5,\n\t\tsin(elapsed * -0.1) * 1.0,\n\t\t0.0\n\t);\n\t\n\tvec3 newOrientation = normalize(\n\t\torientationA + 0.2 * (\n\t\t\t+ normalize(boids.cohesion) * cohesionWeight\n\t\t\t+ normalize(boids.repulsion) * repulsionWeight\n\t\t\t+ normalize(boids.alignment) * alignmentWeight\n\t\t\t+ normalize( target - currPositionA ) * 0.05\n\t\t)\n\t);\n\t\n\tgl_FragColor = vec4(\n\t\tcurrPositionA + newOrientation * velocity,\n\t\t1.0\n\t);\n}",
		uniforms: {
			elapsed : { type : 'f' },
			textureSideLength : { type : 'f' },
			textureCurrPosition : { type : 't' },
			texturePrevPosition : { type : 't' },

			velocity          : { type : 'f', value : config.velocity },
			cohesionDistance  : { type : 'f', value : config.cohesionDistance },
			cohesionWeight    : { type : 'f', value : config.cohesionWeight },
			repulsionDistance : { type : 'f', value : config.repulsionDistance },
			repulsionWeight   : { type : 'f', value : config.repulsionWeight },
			alignmentDistance : { type : 'f', value : config.alignmentDistance },
			alignmentWeight   : { type : 'f', value : config.alignmentWeight },

			mouseDistance     : { type : 'f', value : config.mouseDistance },
			mouseWeight       : { type : 'f', value : config.mouseWeight },			
			mouseOrigin       : { type : 'v3' },
			mouseDirection    : { type : 'v3' },
		},
		defines : {
			TOTALCOUNT : config.count,
		},
		attributes : {}
	})
	
	shaderMaterial.name = "Boids Position Shader"
	
	var updateRaycasting = _raycastingFn( config, poem, shaderMaterial )
	
	var pass = gpuProcessor.addPass( "position", {
		
		size              : config.count,  // Number of vectors in data
		stride            : 3,             // Dimensions of vectors, either 3 or 4
		uniformName       : "textureCurrPosition",
		shaderMaterial    : shaderMaterial,
		generateDatum     : _generatePositionFn( config ),
		preRender         : function( pass, event ) {

			stats( 'boids position' ).start()
			
			shaderMaterial.uniforms.elapsed.value = event.elapsed / 1000
			
			updateRaycasting()
			
			//Copy the previous position
			gpuProcessor.copyTexture(
				pass.outputRenderTarget,
				prevPositionTexture,
				pass.textureSideLength
			)
			
		},
		postRender        : function() {
			stats( 'boids position' ).end()
		}
	})
	
	//Copy one of the render target settings
	prevPositionTexture = pass.renderTargets[0].clone()
	prevPositionTexture.name = "prevPositionTexture"
	
	shaderMaterial.uniforms.textureSideLength.value = pass.textureSideLength
	shaderMaterial.uniforms.texturePrevPosition.value = prevPositionTexture
	
	return {
		pass : pass,
		prevPositionTexture : prevPositionTexture,
		shaderMaterial : shaderMaterial
	}
}

function _createRenderMaterial( config ) {
	
	var shaderMaterial = new THREE.ShaderMaterial({
		
		blending: THREE.AdditiveBlending,
		transparent: true,
		
		vertexShader    : "#define GLSLIFY 1\n\nuniform float elapsed;\n\nuniform float textureSideLength;\nuniform sampler2D textureCurrPosition;\nuniform sampler2D texturePrevPosition;\n\nattribute float attributeIndex;\n\nvarying float vLighting;\nvarying float vAttributeIndex;\n\nmat3 calcLookAtMatrix_2_0(vec3 origin, vec3 target, float roll) {\n  vec3 rr = vec3(sin(roll), cos(roll), 0.0);\n  vec3 ww = normalize(target - origin);\n  vec3 uu = normalize(cross(ww, rr));\n  vec3 vv = normalize(cross(uu, ww));\n\n  return mat3(uu, vv, ww);\n}\n\n\n\nfloat inverse_3_1(float m) {\n  return 1.0 / m;\n}\n\nmat2 inverse_3_1(mat2 m) {\n  return mat2(m[1][1],-m[0][1],\n             -m[1][0], m[0][0]) / (m[0][0]*m[1][1] - m[0][1]*m[1][0]);\n}\n\nmat3 inverse_3_1(mat3 m) {\n  float a00 = m[0][0], a01 = m[0][1], a02 = m[0][2];\n  float a10 = m[1][0], a11 = m[1][1], a12 = m[1][2];\n  float a20 = m[2][0], a21 = m[2][1], a22 = m[2][2];\n\n  float b01 = a22 * a11 - a12 * a21;\n  float b11 = -a22 * a10 + a12 * a20;\n  float b21 = a21 * a10 - a11 * a20;\n\n  float det = a00 * b01 + a01 * b11 + a02 * b21;\n\n  return mat3(b01, (-a22 * a01 + a02 * a21), (a12 * a01 - a02 * a11),\n              b11, (a22 * a00 - a02 * a20), (-a12 * a00 + a02 * a10),\n              b21, (-a21 * a00 + a01 * a20), (a11 * a00 - a01 * a10)) / det;\n}\n\nmat4 inverse_3_1(mat4 m) {\n  float\n      a00 = m[0][0], a01 = m[0][1], a02 = m[0][2], a03 = m[0][3],\n      a10 = m[1][0], a11 = m[1][1], a12 = m[1][2], a13 = m[1][3],\n      a20 = m[2][0], a21 = m[2][1], a22 = m[2][2], a23 = m[2][3],\n      a30 = m[3][0], a31 = m[3][1], a32 = m[3][2], a33 = m[3][3],\n\n      b00 = a00 * a11 - a01 * a10,\n      b01 = a00 * a12 - a02 * a10,\n      b02 = a00 * a13 - a03 * a10,\n      b03 = a01 * a12 - a02 * a11,\n      b04 = a01 * a13 - a03 * a11,\n      b05 = a02 * a13 - a03 * a12,\n      b06 = a20 * a31 - a21 * a30,\n      b07 = a20 * a32 - a22 * a30,\n      b08 = a20 * a33 - a23 * a30,\n      b09 = a21 * a32 - a22 * a31,\n      b10 = a21 * a33 - a23 * a31,\n      b11 = a22 * a33 - a23 * a32,\n\n      det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n\n  return mat4(\n      a11 * b11 - a12 * b10 + a13 * b09,\n      a02 * b10 - a01 * b11 - a03 * b09,\n      a31 * b05 - a32 * b04 + a33 * b03,\n      a22 * b04 - a21 * b05 - a23 * b03,\n      a12 * b08 - a10 * b11 - a13 * b07,\n      a00 * b11 - a02 * b08 + a03 * b07,\n      a32 * b02 - a30 * b05 - a33 * b01,\n      a20 * b05 - a22 * b02 + a23 * b01,\n      a10 * b10 - a11 * b08 + a13 * b06,\n      a01 * b08 - a00 * b10 - a03 * b06,\n      a30 * b04 - a31 * b02 + a33 * b00,\n      a21 * b02 - a20 * b04 - a23 * b00,\n      a11 * b07 - a10 * b09 - a12 * b06,\n      a00 * b09 - a01 * b07 + a02 * b06,\n      a31 * b01 - a30 * b03 - a32 * b00,\n      a20 * b03 - a21 * b01 + a22 * b00) / det;\n}\n\n\nfloat transpose_1_2(float m) {\n  return m;\n}\n\nmat2 transpose_1_2(mat2 m) {\n  return mat2(m[0][0], m[1][0],\n              m[0][1], m[1][1]);\n}\n\nmat3 transpose_1_2(mat3 m) {\n  return mat3(m[0][0], m[1][0], m[2][0],\n              m[0][1], m[1][1], m[2][1],\n              m[0][2], m[1][2], m[2][2]);\n}\n\nmat4 transpose_1_2(mat4 m) {\n  return mat4(m[0][0], m[1][0], m[2][0], m[3][0],\n              m[0][1], m[1][1], m[2][1], m[3][1],\n              m[0][2], m[1][2], m[2][2], m[3][2],\n              m[0][3], m[1][3], m[2][3], m[3][3]);\n}\n\n\n\nvoid main() {\n\t\n\tvec2 uvPosition = vec2(\n\t\tmod(attributeIndex, textureSideLength),\n\t\tfloor(attributeIndex / textureSideLength)\n\t) / textureSideLength;\n\t\n\tvec3 currPosition = texture2D( textureCurrPosition, uvPosition ).xyz;\n\tvec3 prevPosition = texture2D( texturePrevPosition, uvPosition ).xyz;\n\tmat3 rotation = calcLookAtMatrix_2_0(\n\t\tvec3(0.0),                   // origin\n\t\tcurrPosition - prevPosition, // target\n\t\t0.0                          // roll\n\t);\n\t// mat3 rotationNormal = transpose( inverse( rotation ) );\n\t\n\tfloat theta = log(attributeIndex) * 8.0;\n\tfloat r = attributeIndex * 2.0;\n\t\n\tvec4 offset = vec4( r * sin(theta), r * cos(theta), 0.0, 0.0 );\n\t\n\tvec3 newNormal = normalize( transpose_1_2( inverse_3_1( rotation ) ) * normal );\n\t\n\tvLighting = dot( newNormal * vec3(-1.0,-1.0,-1.0), normalize((cameraPosition + vec3(0.0,100.0,0.0)) - position) );\n\tvLighting = vLighting * 0.5 + 0.5;\n\t\n\tvAttributeIndex = attributeIndex;\n\t\n\tgl_Position =\n\t\tprojectionMatrix *\n\t\tmodelViewMatrix * (\n\t\t\tvec4( rotation * position, 1.0 ) + offset * 0.0 + vec4( currPosition * 100.0, 0 )\n\t\t);\n}",
		fragmentShader  : "#define GLSLIFY 1\n\nvarying float vLighting;\nvarying float vAttributeIndex;\n\nfloat hue2rgb_1_0(float f1, float f2, float hue) {\n    if (hue < 0.0)\n        hue += 1.0;\n    else if (hue > 1.0)\n        hue -= 1.0;\n    float res;\n    if ((6.0 * hue) < 1.0)\n        res = f1 + (f2 - f1) * 6.0 * hue;\n    else if ((2.0 * hue) < 1.0)\n        res = f2;\n    else if ((3.0 * hue) < 2.0)\n        res = f1 + (f2 - f1) * ((2.0 / 3.0) - hue) * 6.0;\n    else\n        res = f1;\n    return res;\n}\n\nvec3 hsl2rgb_1_1(vec3 hsl) {\n    vec3 rgb;\n    \n    if (hsl.y == 0.0) {\n        rgb = vec3(hsl.z); // Luminance\n    } else {\n        float f2;\n        \n        if (hsl.z < 0.5)\n            f2 = hsl.z * (1.0 + hsl.y);\n        else\n            f2 = hsl.z + hsl.y - hsl.y * hsl.z;\n            \n        float f1 = 2.0 * hsl.z - f2;\n        \n        rgb.r = hue2rgb_1_0(f1, f2, hsl.x + (1.0/3.0));\n        rgb.g = hue2rgb_1_0(f1, f2, hsl.x);\n        rgb.b = hue2rgb_1_0(f1, f2, hsl.x - (1.0/3.0));\n    }   \n    return rgb;\n}\n\nvec3 hsl2rgb_1_1(float h, float s, float l) {\n    return hsl2rgb_1_1(vec3(h, s, l));\n}\n\n\n\nvoid main() {\n\t\n\tgl_FragColor = vec4(\n\t\thsl2rgb_1_1( mod(0.55 + vAttributeIndex * 0.00002, 1.0), 0.8, 0.6 ),\n\t\t1.0\n\t) * vLighting;\n}",
		
		uniforms: {
			elapsed : { type: 'f', value : 0 },
			textureCurrPosition : { type : 't' },
			texturePrevPosition : { type : 't' },
			textureSideLength : { type : 'f' },
		},
		
		attributes       : {
			attributeIndex : { type: 'f' }
		}
	})
	
	shaderMaterial.name = "Boids Render Shader"
	
	return shaderMaterial
}

function _createGeometry( config ) {
	
	var bufferGeometry = new THREE.BufferGeometry()
	bufferGeometry.fromGeometry( new THREE.OctahedronGeometry( 3 ) )
	bufferGeometry.applyMatrix( new THREE.Matrix4().makeScale( 1, 1, 3 ) )
	DuplicateBufferGeometry( bufferGeometry, config.count )

	return bufferGeometry
}

function _initRenderingPass( config, scene, positioning ) {
	
	var mesh = new THREE.Mesh(
		_createGeometry( config ),
		_createRenderMaterial( config, positioning )
	)
	
	scene.add( mesh )
	return mesh
}

function _raycastingFn( config, poem, shaderMaterial ) {
	
	var raycaster = new THREE.Raycaster();
	var range = config.mouseDistance

	shaderMaterial.uniforms.mouseOrigin.value = raycaster.ray.origin
	shaderMaterial.uniforms.mouseDirection.value = raycaster.ray.direction
	shaderMaterial.uniforms.mouseDistance.value = config.mouseDistance
	
	var mouse = poem[config.mouseRef]
	
	if( !mouse || !mouse.normalizedPosition ) {
		throw new Error("Boids requires a reference to poem.mouse with a .normalizedPosition property")
	}
	
	var mousePosition = mouse.normalizedPosition
	var camera = poem.camera.object
	
	return function(e) {
		raycaster.setFromCamera( mousePosition, camera )
	}
}

module.exports = function boids( poem, props ) {
	
	var config = _.extend({
		count : Math.pow(2,12),
		velocity : 0.005,
		cohesionDistance : 8,
		cohesionWeight : 0.02,
		repulsionDistance : 4,
		repulsionWeight : 0.04,
		alignmentDistance : 8,
		alignmentWeight : 0.04,
		mouseDistance : 20,
		mouseWeight : 0.1,
		mouseRef : "mouse"
	}, props)
	
	var gpuProcessor     = CreateGpuProcessor( poem.renderer )
	var positioning      = _initPositioningPass( poem, gpuProcessor, poem.stats, config )
	var mesh             = _initRenderingPass( config, poem.scene )
	
	poem.emitter.on('update' , function(e) {
		
		gpuProcessor.render(e)
		
		mesh.material.uniforms.textureCurrPosition.value = positioning.pass.outputRenderTarget
		mesh.material.uniforms.texturePrevPosition.value = positioning.prevPositionTexture
		mesh.material.uniforms.textureSideLength.value = positioning.pass.textureSideLength
		mesh.material.uniforms.elapsed.value = e.elapsed
	})
	}